/**
 * Rendered height of a `size="small"` outlined input in this app.
 *
 * Not MUI's stock 40px: the theme sets `typography.fontSize: 12`, so the input
 * font lands at ~13.71px and its `1.4375em` line box at ~19.71px, plus 8.5px of
 * padding top and bottom.
 *
 * Controls sharing a row with those inputs match it explicitly, because a switch
 * or a button has no text box of its own to derive the same height from — which
 * is why this has to be recomputed whenever the theme's base font size moves.
 */
export const SMALL_INPUT_HEIGHT = 36.71;

/**
 * Width shared by the direction and behaviour buttons, so the two controls that
 * open the order row are the same size.
 */
export const ROW_BUTTON_WIDTH = 92;

/**
 * The direction toggle at 80% of that. One control for both sides, with a short
 * label, so it does not need a behaviour button's room.
 */
export const DIRECTION_TOGGLE_WIDTH = ROW_BUTTON_WIDTH * 0.8;

/**
 * Label placement for the Settings fields (quantity, price, tag, and the
 * shimurai fields).
 *
 * They sit side by side on a grid, so a label beside each input would eat that
 * input's width by however long the label is — "Reference price" left its
 * input a few characters wide, and cells in the same column stopped lining up.
 * A caption on top gives every input its cell's full width.
 */
export const SETTINGS_LABEL_PLACEMENT = "top";
